import axios from "axios";
import { LEADS_URL } from "../../API/Api";

const getAllLeads = async (data, token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${LEADS_URL}`,
        headers: headers,
        params: { ...data },
    });
    return response.data;
};

const getSingleLead = async (id, token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${LEADS_URL}/${id}`,
        headers: headers,
    });
    return response.data;
};

const LeadSearch = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        baseURL: `${LEADS_URL}/search`,
        headers,
        params: data,
    });
    return response.data;
};

const updateLead = async (data, token) => {
    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const response = await axios({
        method: "POST",
        baseURL: `${LEADS_URL}/update/${data.id}`,
        headers,
        data,
    });
    return response;
};

const leadService = { getAllLeads, getSingleLead, updateLead, LeadSearch };
export default leadService;
